import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '~/environments';
import { SwalService } from './swal.service';
@Injectable({
  providedIn: 'root',
})
export class VersionCheckService {
  // this will be replaced by actual hash post-build.js
  private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';
  currentVersion: any;
  constructor(private http: HttpClient) {}

  public initVersionCheck(url, frequency = 1000 * 60 * 30): void {
    setInterval(() => {
      this.checkVersion(url);
    }, frequency);
    this.checkVersion(url);
  }

  public checkVersion(url): void {
    this.http
      .get(url + '?t=' + new Date().getTime(), {
        headers: { ignoreLoadingBar: '' },
      })
      .subscribe(
        (response: any) => {
          const { hash, version } = response;
          const hasChanged = this.hasChanged(environment.version, version);
          if (hasChanged) {
            const optionAlert = this.optionAlert(version);
            SwalService.defaultCustomSwal(optionAlert, {}, (result) => {
              if (result.value) {
                window.location.reload();
              }
            });
          }
          this.currentHash = hash;
          this.currentVersion = version;
        },
        (err) => {
          console.error(err, 'Could not get version');
        }
      );
  }

  optionAlert(version) {
    return {
      icon: 'success',
      position: 'top-end',
      html: `<div style="
                          margin: 5px;
                          padding-right: 5px;
                          border-right: 1px solid #eeee;
                          text-align: left;">
                      <div style="margin-bottom: 5px;">
                        <div><strong>Nearly up to date!</strong></div>
                        <span><strong>Reload your browser to finish updating.</strong></span>
                      </div>
                      <div>New version: <b>${version}</b></div>
                      <div>Current version: <b>${environment.version}</b></div>
                    </div>`,
      confirmButtonText: 'Reload',
      toast: true,
    };
  }

  public hasChanged(currentVal, newVal): boolean {
    if (!currentVal || currentVal === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
      return false;
    }
    return currentVal !== newVal;
  }
}
